import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  GeneralLedgerAccountBean,
  GeneralLedgerAccountSearchCriteria,
  RestGeneralLedgerAccountListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyArray } from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class GeneralLedgerAccountListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
  }
  componentDidMount() {}
  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  deleteGeneralLedgerAccount = (e, val, rowData) => {
    if (e.detail === 1) this.props.deleteGeneralLedgerAccount(val, rowData);
  };
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  editGeneralLedgerAccount = (e, val, rowData) => {
    if (e.detail === 1) this.props.editGeneralLedgerAccount(val);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  clickGoButton = (e) => {
    if (e.detail === 1) this.props.clickGoButton(e);
  };
  render() {
    let generalLedgerAccount_list = this.props.generalLedgerAccount_list;
    return (
      <div>
        <div>
          <Row>
            <Col sm="3">
              <FormLabel id="searchBarLabel">General Ledger Account </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.listFormCodeRef}
                enterKeyEventHandler={this.props.enterKeyEventHandler}
                name="code"
                onChange={this.props.onChange}
                value={this.props.generalLedgerAccountData.code}
                style={{ "text-transform": "uppercase" }}
                isMandatory={true}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.clickGoButton(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>

        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "generalLedgerAccountType")
                  }
                >
                  Name
                  {this.props.order === "desc" &&
                  this.props.sortField === "generalLedgerAccountType" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            {generalLedgerAccount_list != null ? (
              <tbody>
                {generalLedgerAccount_list.map((ln, index) => (
                  <tr key={index}>
                    <td>
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.editGeneralLedgerAccount(e, ln.code, ln)
                        }
                      >
                        {ln.code}
                      </Button>
                    </td>
                    <td>{ln.generalLedgerAccountType}</td>
                    <td>{ln.companyCode}</td>
                    <td>{ln.isActive}</td>
                    {/* <td className="text-right">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.deleteGeneralLedgerAccount(e, ln.code, ln)
                        }
                      >
                        {<DeleteIcon />}
                      </Button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {generalLedgerAccount_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
class GeneralLedgerAccountEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
  }
  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  render() {
    let generalLedgerAccountData = this.props.generalLedgerAccountData;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Company</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              type="text"
              name="companyCode"
              onChange={this.onChange}
              value={generalLedgerAccountData.companyCode}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Code </FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              name="code"
              type="text"
              placeholder="Enter Code"
              onChange={this.onChange}
              value={generalLedgerAccountData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              ref={this.codeRef}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>GeneralLedgerAccountType</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              name="generalLedgerAccountType"
              type="text"
              placeholder="Enter Type"
              onChange={this.onChange}
              value={generalLedgerAccountData.generalLedgerAccountType}
              style={{ "text-transform": "uppercase" }}
              isMandatory={true}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Currency</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              onChange={this.props.onCurrencyCodeChange}
              name="currencyCode"
              value={generalLedgerAccountData.currencyCode}
              lookupRequired={true}
              lookupHandler={this.props.currencyLookupHandler}
              enterKeyEventHandler={this.props.currencyEnterKeyEvent}
              autoCompleteListData={
                this.props.currencyCodePageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.props.displayAutoCompleteCurrencyList
              }
              showAutoCompleteList={this.props.showAutoCompleteCurrencyCodeList}
              style={{ "text-transform": "uppercase" }}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Amount</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <NumberFormatInputbox
              name="generalLedgerAccountAmount"
              placeholder="Enter Amount"
              onChange={this.onChange}
              value={generalLedgerAccountData.generalLedgerAccountAmount}
              className="text-right"
              decimalScale={2}
              style={{ "text-transform": "uppercase" }}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Active</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputCheckbox
              name="isActive"
              onChange={this.onChange}
              type="checkbox"
              checked={generalLedgerAccountData.isActive}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

class GeneralLedgerAccountList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      generalLedgerAccount_list: [],
      pageTitle: "General Ledger Account",
      generalLedgerAccountData: new GeneralLedgerAccountBean(),
      pageList: new PageListBean(),
      criteria: new GeneralLedgerAccountSearchCriteria(),
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isListFormOpen: true,
      isEntryFormOpen: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowExitButton: true,
      progressLoadingText: "",
      isShowProgressBarPopup: false,
      isDisableFields: false,
      currencies: new Array(),
      showAutoCompleteCurrencyCodeList: false,
      currencyCodePageListForAutoCompleteList: new Array(),
      currencyLookupHandler: null,
      order: "asc",
      sortField: "",
    };
    this.moduleCaption = "General Ledger Account";
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    let generalLedgerAccountData = new GeneralLedgerAccountBean();
    generalLedgerAccountData.companyCode = this.companyCode;
    this.loadPage(1);
    this.setState({
      generalLedgerAccountData: generalLedgerAccountData,
    });
    this.fetchAttributeCache();
    this.initLookupHandlers();
  }
  fetchAttributeCache = () => {
    const attribute_cache = { ...this.cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let currencies = this.state.currencies;
    if (
      attribute_cache.currencies != null ||
      attribute_cache.currencies != undefined
    ) {
      currencies = attribute_cache.currencies;
    }
    this.state.currencies = currencies;
    this.setState({
      currencies: currencies,
    });
  };
  initLookupHandlers = () => {
    let currencyLookupHandler = new GenericAttributeLookupHandler(
      this.state.currencies,
      "CURRENCY"
    );
    this.setState({
      currencyLookupHandler: currencyLookupHandler,
    });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  onChange = (e) => {
    let generalLedgerAccountData = this.state.generalLedgerAccountData;
    generalLedgerAccountData[e.target.name] = e.target.value;
    this.setState({
      generalLedgerAccountData: generalLedgerAccountData,
    });
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadGeneralLedgerAccountPage(criteria, pageInput);
  };

  save = () => {
    this.saveGeneralLedgerAccountType();
  };
  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeEntryForm();
  };
  cleardata = () => {
    let generalLedgerAccountData = new GeneralLedgerAccountBean();
    generalLedgerAccountData.companyCode = this.companyCode;
    this.setState({
      generalLedgerAccountData: generalLedgerAccountData,
    });
  };
  clickGoButton = () => {
    let generalLedgerAccountData = this.state.generalLedgerAccountData;
    this.editGeneralLedgerAccount(generalLedgerAccountData.code);
  };
  openEntryForm = () => {
    this.setState({
      isListFormOpen: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
      isEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowAlert: false,
    });
  };
  closeEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isListFormOpen: true,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isDisableFields: false,
    });
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.clickGoButton();
    }, 200);
  };
  loadPageResponse = (response) => {
    if (
      response.data != null &&
      response.data.generalLedgerAccountPageListBean
    ) {
      let generalLedgerAccount_list = [];
      if (
        !isEmptyArray(
          response.data.generalLedgerAccountPageListBean
            .generalLedgerAccountBean
        )
      ) {
        generalLedgerAccount_list =
          response.data.generalLedgerAccountPageListBean
            .generalLedgerAccountBean;
        generalLedgerAccount_list.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
        let pageList = this.state.pageList;
        pageList.currentPage =
          response.data.generalLedgerAccountPageListBean.currentPage;
        pageList.pageSize =
          response.data.generalLedgerAccountPageListBean.pageSize;
        pageList.totalCount =
          response.data.generalLedgerAccountPageListBean.totalCount;
        this.setState({
          pageList: pageList,
        });
      }
      this.setState({
        generalLedgerAccount_list: generalLedgerAccount_list,
      });
    }
  };
  loadGeneralLedgerAccountPage = (criteria, pageList) => {
    let requestInput = new RestGeneralLedgerAccountListRequest();
    requestInput.searchCriteria = criteria;
    requestInput.pageInput = pageList;
    if (
      SecurityAccessManager.GeneralLedgerAccountMaintenanceView_IsAccessible()
    ) {
      MasterService.getGeneralLedgerAccountPageList(
        requestInput,
        this.loadPageResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadSaveResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
    this.cleardata();
    this.closeEntryForm();
  };
  saveGeneralLedgerAccountType = () => {
    let input = this.state.generalLedgerAccountData;
    if (input.isFetched == true) {
      if (
        SecurityAccessManager.GeneralLedgerAccountMaintenanceEdit_IsAccessible()
      ) {
        MasterService.updateGeneralLedgerAccount(
          input,
          this.loadSaveResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (
        SecurityAccessManager.GeneralLedgerAccountMaintenanceCreate_IsAccessible()
      ) {
        MasterService.createGeneralLedgerAccount(
          input,
          this.loadSaveResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadEditResponse = (response) => {
    if (response.data != null) {
      if (!isEmptyArray(response.data.generalLedgerAccountBean)) {
        let generalLedgerAccountData = response.data.generalLedgerAccountBean;
        this.setState({
          generalLedgerAccountData: generalLedgerAccountData,
        });
        this.disable();
      }
    }
    this.openEntryForm();
  };
  editGeneralLedgerAccount = (code) => {
    let readRequest = new RestReadRequest();
    readRequest.companyCode = this.companyCode;
    readRequest.code = code;
    if (
      SecurityAccessManager.GeneralLedgerAccountMaintenanceView_IsAccessible()
    ) {
      MasterService.readGeneralLedgerAccount(
        readRequest,
        this.loadEditResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onCurrencyCodeChange = (e) => {
    let currencyCode = e.target.value;
    this.state.showAutoCompleteCurrencyCodeList = true;
    let temp_data = this.state.generalLedgerAccountData;
    let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;
    if (isEmpty(currencyCode)) {
      this.state.showAutoCompleteCurrencyCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;
      let generalLine = this.state.generalLedgerAccountData;
      generalLine.currencyCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCurrencyCodeList: showAutoCompleteList,
        generalLedgerAccountData: generalLine,
        currencyCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && currencyCode !== "") {
      this.readCurrencyCodeBySearchString(currencyCode);
    }
    temp_data["currencyCode"] = e.target.value;
    this.setState({ generalLedgerAccountData: temp_data });
  };
  readCurrencyCodeBySearchString(searchString) {
    let currencyCodeData = this.state.currencies;
    let simpleAutoCompleteList = new Array();
    if (currencyCodeData.length > 0 && currencyCodeData != null) {
      currencyCodeData.map((currency) => {
        let simpleItemBean = {
          code: currency.code,
          description: currency.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (currency) =>
        currency.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      currencyCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  currencyEnterKeyEvent = (e) => {
    let temp_data = this.state.generalLedgerAccountData;
    temp_data["currencyCode"] = e.target.value;
    let currency_List = this.state.currencies;
    let currencyBean = null;
    currency_List.map((currency) => {
      if (currency.code == e.target.value) {
        currencyBean = currency;
      }
    });
    if (!isEmpty(currencyBean)) {
      let temp_data = this.state.generalLedgerAccountData;
      temp_data.currencyCode = currencyBean.code;
      this.setState({
        generalLedgerAccountData: temp_data,
        currencyCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCurrencyList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCurrencyCodeList: showAutoCompleteList });
  };
  deleteGeneralLedgerAccount = (code, rowData) => {
    //
  };

  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.generalLedgerAccount_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ generalLedgerAccount_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <ProgressBar
          closeAlertModalCallBack={this.closeAlertProgressBarModalCallBack}
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
          />
        )}
        {this.state.isListFormOpen && (
          <GeneralLedgerAccountListForm
            {...this.state}
            clickGoButton={this.clickGoButton}
            editGeneralLedgerAccount={this.editGeneralLedgerAccount}
            enterKeyEventHandler={this.enterKeyEventHandler}
            onChange={this.onChange}
            deleteGeneralLedgerAccount={this.deleteGeneralLedgerAccount}
            handleSortingChange={this.handleSortingChange}
          />
        )}
        {this.state.isEntryFormOpen && (
          <GeneralLedgerAccountEntryForm
            {...this.state}
            onChange={this.onChange}
            onCurrencyCodeChange={this.onCurrencyCodeChange}
            currencyEnterKeyEvent={this.currencyEnterKeyEvent}
            displayAutoCompleteCurrencyList={
              this.displayAutoCompleteCurrencyList
            }
          />
        )}
      </div>
    );
  }
}

function GeneralLedgerAccountAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <GeneralLedgerAccountList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default GeneralLedgerAccountAttributeModule;
